import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal, FormGroup } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as action from '../Store/SpecTemplate.action';
import Loader from '../../../../Components/Utility/Loader/Loader';

function EditDocumentModal({ show, data, handlePopup, specTemplateId }) {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const [showLoader, setShowLoader] = useState(false);
  const fileName = data?.documentTitle;
  const fileExtn = data.fileName.substr(data.fileName.lastIndexOf('.') + 1);

  useEffect(() => {
    setValue('fileName', fileName);
    setValue('fileExtn', fileExtn);
  }, [fileName, fileExtn, setValue]);

  const onSubmit = async (obj) => {
    const params = {
      fileName: `${obj?.fileName?.trim()}.${obj?.fileExtn?.trim()}`,
      id: data._id,
      documentTitle: obj?.fileName?.trim(),
    };
    if (specTemplateId) {
      params.specTemplateId = specTemplateId;
    }
    await setShowLoader(true);
    const res = await dispatch(action.updateDocuments(params, t));
    await setShowLoader(false);
    if (res.code === 200) {
      handlePopup(true);
    }
  };

  return (
    <Modal show={show} size="md" backdrop="static" aria-labelledby="contained-modal-title-vcenter" className="custom-modal modal-small">
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title id="contained-modal-title-vcenter">{t('SPEC_TEMP_LIBRARY.EDIT_NAME')}</Modal.Title>
          <span onClick={handlePopup} className="icon-close cursor-pointer" />
        </div>
      </Modal.Header>
      <Modal.Body>
        {showLoader ? (
          <Loader />
        ) : (
          <>
            <FormGroup>
              <div className="input-group form-floating-label fixed-label">
                <input
                  type="text"
                  name="fileName"
                  {...register('fileName', {
                    required: true,
                    validate: (value) => !!value.trim() || 'no whitespaces.',
                  })}
                  placeholder={t('SPEC_TEMP_LIBRARY.COL_DOC_TITLE')}
                  className="form-control"
                />
                <label className="asterisk-req">
                  {t('SPEC_TEMP_LIBRARY.COL_DOC_TITLE')}
                  <span>*</span>
                </label>
              </div>
              {errors.fileName && <small className="error-message">{t('SPEC_TEMP_LIBRARY.DOC_TIT_REQUIRED')}</small>}
            </FormGroup>
            <div className="modal-buttons mt-4 d-flex justify-content-between">
              <button onClick={() => handlePopup(false)} type="button" className="btn btn-default">
                {t('SPEC_TEMP_LIBRARY.CANCEL')}
              </button>
              <button onClick={handleSubmit(onSubmit)} type="button" className="btn btn-default">
                {t('SPEC_TEMP_LIBRARY.SUBMIT')}
              </button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default EditDocumentModal;
